exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown label {\n  display: inline;\n  color: #56585a;\n}\n.dropdown select {\n  border-radius: 0;\n  background: transparent;\n  border: 1px solid #9c9c9c;\n  margin: 0 24px 0 8px;\n}\n.dropdown .icon {\n  display: inline-block;\n  position: relative;\n  left: -42px;\n  top: -2px;\n}\n.tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.tooltip .tooltiptext {\n  visibility: hidden;\n  min-width: 120px;\n  background-color: #56585a;\n  color: #fff;\n  text-align: left;\n  padding: 5px 10px;\n  border-radius: 5px;\n  position: absolute;\n  z-index: 1;\n  top: -5px;\n  left: 110%;\n}\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\npre {\n  overflow-y: auto;\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman-log-view/sysman-log-view.component.less
// module id = 1471
// module chunks = 2